<template>
  <b-card>
    <confirmDeleteModal
      :data="DeviceData"
      @Blocked="fetchDetails"
    />
    <b-card-title class="d-flex justify-content-between align-items-center">
      <h2>Device Information</h2>
      <h4
        v-if="errMessage"
        class="text-danger"
      >
        {{ errMessage }}
      </h4>
    </b-card-title>
    <base-overlay :show="loading">
      <b-button
        v-if="$can('write', 'users')"
        variant="primary"
        @click="newDevice"
      >
        Add Device
      </b-button>
      <hr>
      <template v-if="!loading">
        <DeviceDetailsForm
          v-for="item in data"
          :key="item.id"
          :data="item"
          :user="user"
          @submitted="fetchDetails"
          @Blocked="fetchDetails"
          @Confirm="ConfirmDeleteHandler"
        />
      </template>
    </base-overlay>
  </b-card>
</template>

<script>
import { BCard, BCardTitle, BButton } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import DeviceDetailsForm from './DeviceDetailsForm.vue'
import confirmDeleteModal from './confirmDeleteModal.vue'

export default {
  components: {
    BCard, BCardTitle, BButton, DeviceDetailsForm, confirmDeleteModal,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  setup(props, ctx) {
    const loading = ref(false)
    const data = ref(null)
    const errMessage = ref(null)
    const showForm = ref(false)
    const DeviceData = ref(null)
    const fetchDetails = async () => {
      loading.value = true
      errMessage.value = null
      data.value = null
      try {
        data.value = await ctx.root.$store.dispatch('users/fetchUserDevices', {
          id: props.user.id,
        })
      } catch (error) {
        errMessage.value = error?.response?.data?.error?.message
      } finally {
        loading.value = false
      }
    }
    const newDevice = () => {
      data.value.unshift({
        device_id: null,
        device_type: 'ANDROID',
        supports_google: false,
        application_version: null,
        operating_system: null,
        status: 'PENDING',
        added_by: 'MANUAL',
        newDevice: true,
      })
    }
    const ConfirmDeleteHandler = Devicedata => {
      DeviceData.value = Devicedata
      ctx.root.$bvModal.show('confirm-delete-modals')
    }
    fetchDetails()
    return {
      newDevice,
      fetchDetails,
      ConfirmDeleteHandler,
      loading,
      data,
      errMessage,
      showForm,
      DeviceData,
    }
  },
}
</script>

<style>

</style>
